export interface UserSession {
  isAuthenticated: boolean;
  isWebstoreOrderEnabled: boolean;
  isCod: boolean;
}

interface Action {
  type: string;
  payload: boolean | { isAuthenticated: boolean; isCod: boolean };
}

const defaultState: UserSession = {
  isAuthenticated: false,
  isWebstoreOrderEnabled: false,
  isCod: false,
};

function userSession(state = defaultState, action: Action) {
  switch (action.type) {
    case "SET_LOGIN_STATUS":
      if (typeof action.payload === "object") {
        return Object.assign({}, state, {
          isAuthenticated: action.payload.isAuthenticated,
          isCod: action.payload.isCod,
        });
      }
      return Object.assign({}, state, { isAuthenticated: action.payload });
    case "SET_IS_WEBSTORE_ORDER_ENABLED":
      return Object.assign({}, state, {
        isWebstoreOrderEnabled: action.payload,
      });
    default:
      return state;
  }
}

export default userSession;
